import {Injectable} from "@angular/core";
import {Http} from "@angular/http";
import {TaxesApi} from "../../src/app/shared/sdk/services/custom/Taxes";

@Injectable()
export class TaxesUtils {

  constructor(protected http: Http,
              protected taxesApi: TaxesApi) {
  }

  public loadTaxes(statesIncomes: any) {

    let orFilter: any = [];

    for (let state in statesIncomes) {
      for (let incomeKey of statesIncomes[state]) {
        orFilter.push({state: state, income_key: incomeKey});
      }
    }

    return this.taxesApi.find({where: { or: orFilter }});
  }
}



// WEBPACK FOOTER //
// ./common/utils/taxesutils.ts